export const storageKeys = {
	accessToken: 'handler:accessToken',
	name: 'handler:name',
	email: 'handler:email',
	admin: 'handler:admin',
	theme: 'handler:theme'
};
